module.exports = __webpack_public_path__ + "static/media/sp26.2471565a.JPG";